export default {"src":"/_next/static/media/EthereumMainnetIcon.a4100e96.svg","height":27,"width":27};